var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.neopassDatas[_vm.constants.PAGE_NEOPASS_FORM_PARCOURS] && _vm.neopassDatas[_vm.constants.PAGE_NEOPASS_FORM_PARCOURS].length > 0 ? _c('div', [_c('h3', {
    staticClass: "xl:my-15"
  }, [_vm._v("Stages")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 gap-5 justify-between"
  }, [_c('div', {
    staticClass: "col-span-2 lg:col-span-1 flex flex-col items-center w-full"
  }, [_c('h5', {
    staticClass: "text-indigo-600 text-xl font-semibold my-8"
  }, [_vm._v("\n        Durées de stage\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "border-dashed border-gray-600 rounded-2xl border-2 p-5 w-full md:w-max"
  }, [_c('div', {
    staticClass: "border-dashed border-gray-600 border-b-2 pb-5 flex space-x-3 items-center"
  }, [_c('div', {
    staticClass: "border-2 rounded-full border-indigo-600 p-1.5"
  }, [_c('icon', {
    staticClass: "text-indigo-600 h-4 w-4",
    attrs: {
      "name": "collapse"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-indigo-600"
  }, [_vm._v("\n            " + _vm._s(parseInt(_vm.stageDurationInformations.avg)) + "h\n          ")]), _vm._v(" "), _c('div', [_vm._v("Durée moyenne des stages")])]), _vm._v(" "), _c('div', {
    staticClass: "border-dashed border-gray-600 border-b-2 py-5 flex space-x-3 items-center"
  }, [_c('div', {
    staticClass: "border-2 rounded-full border-pink-600 p-1.5"
  }, [_c('icon', {
    staticClass: "text-pink-600 h-4 w-4",
    attrs: {
      "name": "arrow-up"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-pink-600"
  }, [_vm._v("\n            " + _vm._s(_vm.stageDurationInformations.max) + "h\n          ")]), _vm._v(" "), _c('div', [_vm._v("Durée du stage le plus long")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-5 flex space-x-3 items-center"
  }, [_c('div', {
    staticClass: "border-2 rounded-full border-pink-600 p-1.5"
  }, [_c('icon', {
    staticClass: "text-pink-600 h-4 w-4",
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-pink-600"
  }, [_vm._v("\n            " + _vm._s(_vm.stageDurationInformations.min) + "h\n          ")]), _vm._v(" "), _c('div', [_vm._v("Durée du stage le plus court")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 lg:col-span-1"
  }, [_c('doughnut', {
    attrs: {
      "id-chart": "typeStage",
      "title": "Types de stages",
      "labels": _vm.typesStage.longLabels,
      "values": _vm.typesStage.datas,
      "thickness": "70",
      "colors": [_vm.color('pink'), _vm.color('indigo')],
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 md:col-span-1"
  }, [_c('doughnut', {
    attrs: {
      "id-chart": "environnementStage",
      "title": "Environnement de stage",
      "labels": _vm.environnementsStage.longLabels,
      "values": _vm.environnementsStage.datas,
      "thickness": "70",
      "colors": [_vm.color('pink'), _vm.color('indigo')],
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 md:col-span-1"
  }, [_c('doughnut', {
    attrs: {
      "id-chart": "caracteristiqueStage",
      "title": "Caractéristiques du stage",
      "labels": _vm.caracteristiquesStage.longLabels,
      "values": _vm.caracteristiquesStage.datas,
      "thickness": "70",
      "colors": [_vm.color('pink'), _vm.color('indigo')],
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1)]), _vm._v(" "), _c('h3', {
    staticClass: "xl:my-15"
  }, [_vm._v("Formations continues")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-2 space-5 justify-center items-center"
  }, [_c('div', {
    staticClass: "col-span-full flex flex-col items-center"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('bar', {
    attrs: {
      "id-chart": "certifications",
      "title": "Certifications obtenues",
      "orientation": "vertical",
      "labels": _vm.certifications.shortLabels,
      "values": _vm.certifications.datas,
      "thickness": "10",
      "height": "400",
      "width": "400",
      "stacked": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "self-start ml-5"
  }, _vm._l(_vm.certifications.longLabels, function (lib, n) {
    return _c('p', {
      key: n,
      staticClass: "text-2sm text-gray-600"
    }, [_vm._v("\n          " + _vm._s(lib) + "\n        ")]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 lg:col-span-1 flex flex-col items-center"
  }, [_c('h5', {
    staticClass: "text-indigo-600 text-xl font-semibold my-8"
  }, [_vm._v("\n        Durées des formations\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "border-dashed border-gray-600 rounded-2xl border-2 p-5 w-full md:w-max"
  }, [_c('div', {
    staticClass: "border-dashed border-gray-600 border-b-2 pb-5 flex space-x-3 items-center"
  }, [_c('div', {
    staticClass: "border-2 rounded-full border-indigo-600 p-1.5"
  }, [_c('icon', {
    staticClass: "text-indigo-600 h-4 w-4",
    attrs: {
      "name": "collapse"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-indigo-600"
  }, [_vm._v("\n            " + _vm._s(parseInt(_vm.formationDurationInformations.avg)) + "h\n          ")]), _vm._v(" "), _c('div', [_vm._v("Durée moyenne des formations")])]), _vm._v(" "), _c('div', {
    staticClass: "border-dashed border-gray-600 border-b-2 py-5 flex space-x-3 items-center"
  }, [_c('div', {
    staticClass: "border-2 rounded-full border-pink-600 p-1.5"
  }, [_c('icon', {
    staticClass: "text-pink-600 h-4 w-4",
    attrs: {
      "name": "arrow-up"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-pink-600"
  }, [_vm._v("\n            " + _vm._s(_vm.formationDurationInformations.max) + "h\n          ")]), _vm._v(" "), _c('div', [_vm._v("Durée de la formation la plus longue")])]), _vm._v(" "), _c('div', {
    staticClass: "pt-5 flex space-x-3 items-center"
  }, [_c('div', {
    staticClass: "border-2 rounded-full border-pink-600 p-1.5"
  }, [_c('icon', {
    staticClass: "text-pink-600 h-4 w-4",
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xl text-pink-600"
  }, [_vm._v("\n            " + _vm._s(_vm.formationDurationInformations.min) + "h\n          ")]), _vm._v(" "), _c('div', [_vm._v("Durée de la formation la plus courte")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 lg:col-span-1"
  }, [_c('doughnut', {
    attrs: {
      "id-chart": "typeFormation",
      "title": "Types de formations",
      "labels": _vm.typesFormation.longLabels,
      "values": _vm.typesFormation.datas,
      "thickness": "70",
      "colors": [_vm.color('pink'), _vm.color('indigo')],
      "position-legend": "bottom",
      "height": "400",
      "width": "400"
    }
  })], 1)])]) : _c('div', {
    staticClass: "text-center mt-1/10 text-gray-600"
  }, [_vm._v("\n  Aucune donnée à afficher.\n")]);

}
var staticRenderFns = []

export { render, staticRenderFns }